import yup from '../../../config/yup';

export const edReadyReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('edReadyReader'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    token: yup.string().transform((value) => value?.trim()),
    headerJson: yup.string().transform((value) => value?.trim()),
    pagination: yup.string().transform((value) => value?.trim()),
    url: yup.string().transform((value) => value?.trim()),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .transform((value) => value?.trim()),
    body: yup.string().transform((value) => value?.trim()),
  }),
});
